import CreateNoteBookComponent from "./components/CreateNoteBookComponent";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

const createNoteBookApiRequest = async (formInputs) => {
    const { data } = await axios.post(`/api/noteBooks/admin`, { ...formInputs });
    return data;
};

const AdminCreateNoteBookPage = () => {

    return (
        <CreateNoteBookComponent
            createNoteBookApiRequest={createNoteBookApiRequest}
        />
    );
};

export default AdminCreateNoteBookPage;